import {
  getCalfiles,
  deleteCalfile,
  deleteWarning,
} from '@/api';

export default {
  // 校准文件列表
  async fetchCaluploads({ commit }) {
    const res = await getCalfiles();
    commit('setCaluploads', { caluploads: res.data.caluploads });
  },
  async deleteCalfile({ commit }, { filename }) {
    const res = await deleteCalfile({ filename });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    commit('deleteCalfile', { filename });
  },
  // 删除预警
  async deleteWarning({ state }, { deviceId, warningIds }) {
    const res = await deleteWarning({ deviceId, ids: warningIds });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    const device = state.device.devices.find(d => d.id === deviceId);
    const ids = new Set(warningIds);
    const warnings = device.Warnings.filter(w => !ids.has(w.id));
    device.Warnings = warnings;
  },
};

